const funcNav = (() => {

  
  // let nav = document.getElementById('jsNav');
  // let navBtn = document.getElementById('jsNavBtn');

  // navBtn.addEventListener('click', (event) => {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   if (navBtn.classList.contains('act') == true) {
  //     nav.classList.remove('act');
  //     navBtn.classList.remove('act');
  //   } else {
  //     nav.classList.add('act');
  //     navBtn.classList.add('act');
  //   }
  // });


  const gBtn = document.querySelector('.g_menu_btn');
  const gNav = document.querySelector('.g_nav');
  gBtn.addEventListener('click', function () {
    this.classList.toggle('active');
    gNav.classList.toggle('active');
  });


})();
export default funcNav;